const Util = {};
Util.userUrl = window.global_config.BASE_URL
Util.imageUrl1 = window.global_config.BASE_IMG_URL
export default Util;


// WEBPACK FOOTER //
// ./src/common/js/util.js